module.exports = __webpack_public_path__ + "img/look_top_device.7669430d.png";